import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Element from 'element-ui'
import locale from 'element-ui/lib/locale/lang/pl'
import 'element-ui/lib/theme-chalk/index.css'

import VueKonva from 'vue-konva'

Vue.use(VueKonva)

Vue.config.productionTip = false

Vue.use(Element, { locale })

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
